<template>
  <footer
    class="footer"
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="copyright">
        by {{ storeNow ? storeNow.name : '賣店' }} 連絡電話: {{ storeNow.customer_service_phone_number }}
      </div>
    </div>
  </footer>
</template>
<script>
import {CURRENT_STORE_QUERY} from '@/services/graphql/store';

export default {
  props: {
    backgroundColor: String,
    type: String
  },
  apollo: {
    storeNow: {
      query: CURRENT_STORE_QUERY,
    },
  },
  data() {
    return {
      storeNow: {},
      year: new Date().getFullYear()
    };
  }
};
</script>
<style lang="scss" scoped>
</style>
